export default "__VITE_ASSET__smyApB$y__"